import { render, staticRenderFns } from "./teamDashboard.vue?vue&type=template&id=533f3518&scoped=true&"
import script from "./teamDashboard.vue?vue&type=script&lang=ts&"
export * from "./teamDashboard.vue?vue&type=script&lang=ts&"
import style0 from "./teamDashboard.vue?vue&type=style&index=0&id=533f3518&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "533f3518",
  null
  
)

export default component.exports